<template>
    <v-container class="bg-white rounded-2 h-100 d-flex align-center justify-center">
        <v-col cols="11" sm="8" class="card-content text-center"
               :style="$vuetify.breakpoint.smAndDown && 'font-size: 15px'">
            <h3 class="pb-4">
                Ops... Parece que seu link é inválido ou expirou.
            </h3>
            <span>
                Entre em contato com o administrador para gerar um novo link.
            </span>
        </v-col>
    </v-container>
</template>

<script>
export default {
    name: "UnavailableLinkCreate"
}
</script>

<style scoped>
.card-content {
    max-width: 680px;
    color: #454545;
    border: 1px solid #7c7c7c;
    border-radius: 16px;
    padding: 2rem;
}
</style>
